import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import { getSectionOneCurrentFields } from 'AppSrc/core/components/forms/form-types/completion-review/section-one/section-one';
import { getSectionTwoCurrentFields } from 'AppSrc/core/components/forms/form-types/completion-review/section-two/section-two';
import { getSectionThreeCurrentFields } from 'AppSrc/core/components/forms/form-types/completion-review/section-three/section-three';
import { getSectionFailureCurrentFields } from 'AppSrc/core/components/forms/form-types/completion-review/section-failure/section-failure';
import { getSectionCiCurrentFields } from 'AppSrc/core/components/forms/form-types/completion-review/section-ci/section-ci';
import { MOBILE, FIXED } from 'AppSrc/core/components/forms/value-dependency-constants';
import mapValues from 'lodash/mapValues';
import { CRQ_TRANSITION_CONFIRMATION } from 'AppSrc/core/components/router/routes';
import {
  CLOSE_CRQ,
  CLOSE_OLO_CRQ,
} from 'AppSrc/core/crq/crq-status-transitions';
import {
  pick,
  isEmpty,
  omit,
} from 'underscore';
import {
  isStatusCompleted,
  isStatusImplementation,
  CRQ_STATUSES,
  isStatusClosed,
} from 'AppSrc/core/crq/crq-statuses';
import { isUnsuccessfulStatusReason } from 'AppSrc/core/crq/crq-status-reasons';
import {
  formDataShape,
  errorsPropShape,
} from '../../form-base-components/data-structure/v-f-proptypes';
// utilite functions which bridge a bit of a gap between what Formik offers and what we want
import {
  // function that returns an object with each field and that field's errors
  validateFormFields,
  // function to tell the user if the form is in a submittable state
  isSectionReadyToSubmit,
  // function to format the data so it's usable in various places
  createFieldDataObjAndArray,
  // Renders a bit at the top of the form saying there are errors
  // inlineErrorsAreViewable,
  // function to format the data so it's usable in various places
  // gets the initial values for the form based on getCurrentFields
  getInitialValues,
} from '../../form-section-utility-functions';
import {
  getSectionFieldIds,
} from './form-utility-functions';
import {
  formikValuesShape,
  formikTouchedShape,
} from '../../form-base-components/data-structure/formik-proptypes';
import { SectionFields } from './section-fields';
import 'AppSrc/core/style/components/form/form.css';

const generateDataToRedux = (params) => {
  const {
    getCurrentFields,
    sectionTitle,
    sectionId,
    values,
    formData,
    network,
  } = params;

  const currentFields = getCurrentFields({
    values,
    formData,
    network,
  });

  const {
    dataByFieldId,
    fieldIdsByDisplayOrder,
  } = createFieldDataObjAndArray({
    currentFields,
    values,
    selectedNetwork: network,
  });

  const data = {
    // this is for sending to server
    dataByFieldId,
    // this is to show the user
    fieldIdsByDisplayOrder,
    sectionTitle,
    sectionId,
  };
  return data;
};

const getAllFieldsTouched = (values) => {

  const allFieldKeys = Object.keys(values);
  const allFieldsTouched = {};

  allFieldKeys.forEach((fieldId) => {
    allFieldsTouched[fieldId] = true;
  });

  return allFieldsTouched;
};

const moveToNextStatus = (currentStatus) => {
  if (isStatusImplementation(currentStatus)) {
    return CRQ_STATUSES.complete;
  }
  if (isStatusCompleted(currentStatus)) {
    return CRQ_STATUSES.closed;
  }
  return null;
};
class FormSectionDisplay extends PureComponent {
  constructor(props) {
    super(props);
    this.handleSaveToRedux = this.handleSaveToRedux.bind(this);
    this.handleUserSubmit = this.handleUserSubmit.bind(this);
    this.handleSaveChanges = this.handleSaveChanges.bind(this);
    this.getSilentErrorMsgForDisplay = this.getSilentErrorMsgForDisplay.bind(this);
    this.formStartRef = React.createRef();
  }


  componentDidMount() {
    // Calls formiks validator
    this.props.validateForm();
  }

  componentWillUnmount() {
    const {
      getCurrentFields,
      sectionTitle,
      sectionId,
      values,
      formData,
    } = this.props;
    const data = generateDataToRedux({
      getCurrentFields,
      sectionTitle,
      sectionId,
      values,
      formData,
    });
    this.props.saveSectionData(data);
  }

  getSilentErrorMsgForDisplay(errors) {
    if (isEmpty(errors)) {
      return null;
    }
    const errorValues = mapValues(errors, (err) => (err.silentErrors ? err.silentErrors[0] : null));
    const values = !isEmpty(errorValues) ? Object.values(errorValues)[0] : null;
    return values;
  }

  handleSaveToRedux(newStatus = null, successPath = null) {
    const {
      handleSuccessfulSubmit,
      getCurrentFields,
      sectionTitle,
      sectionId,
      values,
      formData,
    } = this.props;
    const data = generateDataToRedux({
      getCurrentFields,
      sectionTitle,
      sectionId,
      values,
      formData,
    });
    handleSuccessfulSubmit(data, newStatus, successPath);
  }

  handleUserSubmit(e) {
    const {
      errors,
      values,
      network,
      isOLO,
      crqId,
      setModalDisplay,
      formData,
    } = this.props;
    const allFieldsTouched = getAllFieldsTouched(values);
    this.props.setTouched(allFieldsTouched, true);
    if (!isEmpty(errors)) {
      return null;
    }
    const newStatus = moveToNextStatus(formData.status);
    if (isOLO) {
      const isUnsuccessful = isUnsuccessfulStatusReason(values.status_reason, network);

      if (isUnsuccessful) {
        // set Status reason to 'Closure - Unsuccessful' (Status reason TBC)
        // const statusReason = 'Closure - Unsuccessful';

        const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
          network,
          crqId,
          transitionId: CLOSE_OLO_CRQ,
        });
        this.handleSaveToRedux(newStatus, successPath);
        setModalDisplay(true);
      }
      else {
        const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
          network,
          crqId,
          transitionId: CLOSE_OLO_CRQ,
        });
        this.handleSaveToRedux(newStatus, successPath);
        setModalDisplay(true);
      }
      return null;
    }
    // move status to Completed
    this.handleSaveToRedux(newStatus);
    setModalDisplay(true);
    return null;
  }

  // for failure review save changes
  // if user has completed all failure answers then submit data
  // and change status to closed
  // if has not completed all answers
  // just save the changes
  handleSaveChanges() {
    const {
      errors,
      network,
      crqId,
      values,
      formData,
    } = this.props;
    const allFieldsTouched = getAllFieldsTouched(values);
    this.props.setTouched(allFieldsTouched, true);
    const SectionFailureReview = getSectionFailureCurrentFields();
    const hasErrors = omit(errors, getSectionFieldIds(SectionFailureReview));
    const canIgnoredErrors = pick(errors, getSectionFieldIds(SectionFailureReview));
    const newStatus = moveToNextStatus(formData.status);
    if (isEmpty(hasErrors)) {
      // save changes
      // status remains completed
      if (!isEmpty(canIgnoredErrors)) {
        this.handleSaveToRedux();
        return null;
      }
      const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({
        network,
        crqId,
        transitionId: CLOSE_CRQ,
      });
      this.handleSaveToRedux(newStatus, successPath);
    }
    return null;
  }


  render() {
    const {
      formData,
      values,
      touched,
      network,
      errors,
      isOLO,
      summaryRead,
    } = this.props;
    const {
      status,
      statusReason,
    } = formData;

    const isUnsuccessful = isUnsuccessfulStatusReason(statusReason, network);
    const isFailureReview = isUnsuccessful && (isStatusCompleted(status) || isStatusClosed(status));
    // section fields
    const SectionOne = getSectionOneCurrentFields({
      values,
      network,
      isOLO,
      formData,
    });
    const SectionTwo = getSectionTwoCurrentFields({ formData, isOLO });
    const SectionThree = getSectionThreeCurrentFields({ network, isOLO, statusReason });
    const SectionCi = network === MOBILE ? getSectionCiCurrentFields({ formData }) : [];
    const SectionFailureReview = isFailureReview ? getSectionFailureCurrentFields({ values, network }) : [];
    // is ready submit
    const readyToSubmit = isSectionReadyToSubmit(errors) && status !== '11';

    // section errors
    const sectionFailureErrors = pick(errors, getSectionFieldIds(SectionFailureReview));
    const trueFlag = true;
    const falseFlag = false;

    window.localStorage.setItem('statusReason', statusReason);
    return (
      <form
        className="formik-form"
      >
        <div
          tabIndex="-1"
          className="hidden-but-can-focus"
          ref={this.formStartRef}
        />
        {
          !isOLO && (
            <>
              <SectionFields
                formData={formData}
                fields={SectionOne}
                subSectionId="POST_CHANGE_QUESTIONNAIRE"
                touched={touched}
                errors={errors}
                summaryRead={summaryRead}
                readOnly={status === '10' && (statusReason === '6200' || statusReason === 'Unsuccessful') ? trueFlag : falseFlag}
              />
              {
                SectionFailureReview.length > 0 && (
                  <SectionFields
                    formData={formData}
                    fields={SectionFailureReview}
                    summaryRead={summaryRead}
                  />
                )
              }
              {
                network === MOBILE && (
                  <SectionFields
                    formData={formData}
                    fields={SectionCi}
                    subSectionId="CI_UNAVAILABILITY"
                    touched={touched}
                    errors={errors}
                    readOnly={summaryRead}
                    selectedNetwork="mobile"
                  />
                )
              }
              <SectionFields
                formData={formData}
                fields={SectionTwo}
                subSectionId="ACTUAL_CHANGE_WINDOW"
                touched={touched}
                errors={errors}
                summaryRead={summaryRead}
              />
              <SectionFields
                formData={formData}
                fields={SectionThree}
                readOnly={trueFlag}
              />
              <p className="v-f-paragraph">
                Please note: Post Change comms will be sent to the same distribution list that Initial Comms were sent to.
              </p>
            </>
          )
        }
        {
          isOLO && network === FIXED && (
            <>
              <SectionFields
                formData={formData}
                fields={SectionTwo}
              />
              <SectionFields
                formData={formData}
                fields={SectionThree}
                readOnly={(status === '10' || status === '11') ? trueFlag : falseFlag} // for status 10 & 11, post change comms selectors have been disabled.
              />
              <p className="v-f-paragraph">
                Please note: Post Change comms will be sent to the same distribution list that Initial Comms were sent to.
              </p>
            </>
          )
        }
        {
          (!summaryRead || isOLO) && (
            <div className="submit-right-button-container">
              <div className="side-left" />
              <div className="side-right">
                {
                  (isFailureReview && !isOLO)
                    ? (
                      <button
                        type="button"
                        className={`submit-button submit-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                        disabled={!readyToSubmit}
                        onClick={this.handleSaveChanges}
                        style={{ width: isEmpty(sectionFailureErrors) ? '250px' : '' }}
                      >
                        {
                          isEmpty(sectionFailureErrors) ? 'Submit and Close CRQ' : 'Save changes'
                        }
                      </button>
                    )
                    : (
                      <button
                        type="button"
                        className={`submit-button submit-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                        onClick={this.handleUserSubmit}
                        disabled={!readyToSubmit}
                      >
                        Submit
                      </button>
                    )
                }
              </div>
            </div>
          )
        }
      </form>
    );
  }
}

// extract withFormik parameters into a seperate object, for ease of testing
const formSectionFormikData = {
  // values for the fields on render
  // the withFormik version uses mapPropsToValues instead of initialValues
  // the function takes props and has the same form as getInitialValues
  // so we can just use that.
  mapPropsToValues: getInitialValues,
  // calles the validator on fields requesting validation
  validate: (
    values,
    {
      getCurrentFields,
      formData,
      sectionId,
      network,
    },
  ) => {
    // Formik's validate functions does not have any error catching so it silently fails
    // unless we do our own...

    try {
      const currentFields = getCurrentFields({
        values,
        formData,
        network,
      });
      return validateFormFields({
        currentFields,
        values,
        formData,
      });
    }
    catch (codeError) {
      console.error(codeError);
      return null;
    }
  },
  // in withFormik onSubmit becomes handleSubmit
  handleSubmit: (
    values,
    {
      props: {
        handleSuccessfulSubmit,
        formData,
        sectionId,
      },
      setSubmitting,
    },
  ) => {
    setSubmitting(false);
    window.localStorage.setItem('validation', false);
    handleSuccessfulSubmit(values);
  },
};

// Add formik functionality and props to the FormSectionDisplay component
const GetCompletionReviewSection = withFormik(formSectionFormikData)(FormSectionDisplay);



FormSectionDisplay.propTypes = {
  handleSuccessfulSubmit: PropTypes.func,
  getCurrentFields: PropTypes.func,
  sectionTitle: PropTypes.string,
  sectionId: PropTypes.string,
  formData: formDataShape,
  network: PropTypes.string,
  values: formikValuesShape,
  touched: formikTouchedShape,
  validateForm: PropTypes.func,
  setTouched: PropTypes.func,
  summaryRead: PropTypes.bool,
  isOLO: PropTypes.bool,
  setModalDisplay: PropTypes.func,
  crqId: PropTypes.string,
  errors: errorsPropShape,
  saveSectionData: PropTypes.func,
};

export { GetCompletionReviewSection, FormSectionDisplay, formSectionFormikData };
